import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    TextField,
    Box,
    Alert,
    CircularProgress,
} from "@mui/material"
import { Close as CloseIcon } from "@mui/icons-material"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"
import {formatOrderMoney} from "../../../components/orders/order-money"

const OrderRejectDialog = ({ open, onClose, order, onConfirm, loading, error, uncertain }) => {
    const { t, i18n } = useTranslation()
    const [reason, setReason] = useState("")

    const handleConfirm = () => {
        onConfirm(reason, order.orderNumber)
    }

    const handleClose = () => {
        if (loading) { return; }
        onClose()
        setReason("")
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <CloseIcon color="error" />
                {t("RejectOrder")}
            </DialogTitle>
            <DialogContent>
                {error && <Alert severity="error" sx={{mb: 2}}>{t(error)}</Alert>}
                <Typography variant="body1" sx={{ mb: 2 }}>
                    {t("RejectOrderConfirmation")} <strong>{order?.orderNumber}</strong>?
                </Typography>

                {order && (
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" color="text.secondary" gutterBottom>
                            {t("OrderDetails")}:
                        </Typography>
                        <Box sx={{ pl: 2 }}>
                            <Typography variant="body2">
                                <strong>{t("Customer")}:</strong> {order.pharmacyName}
                            </Typography>
                            <Typography variant="body2">
                                <strong>{t("Subtotal")}:</strong> {formatOrderMoney(order.totalPrice, order.currency, i18n.language)}
                            </Typography>
                            <Typography variant="body2">
                                <strong>{t("Items")}:</strong> {order.productCount} {t("Items")}
                            </Typography>
                        </Box>
                    </Box>
                )}

                <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label={t("RejectionReason")}
                    placeholder={t("RejectionReasonPlaceholder")}
                    value={reason}
                    disabled={loading || uncertain}
                    inputProps={{maxLength: 255}}
                    onChange={(e) => setReason(e.target.value)}
                    sx={{ mb: 2 }}
                />

                <Alert severity="warning">
                    {t("OrderRejectedDesc")}
                </Alert>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} disabled={loading}>
                    {t("Cancel")}
                </Button>
                <Button
                    onClick={handleConfirm}
                    variant="contained"
                    color="error"
                    disabled={loading || !reason.trim()}
                    startIcon={loading ? <CircularProgress size={16} /> : <CloseIcon />}
                >
                    {loading ? t("Rejecting") : t(uncertain ? "Retry" : "RejectOrder")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default OrderRejectDialog
